import GetFeatureToggles from './GetFeatureToggles'

export default GetFeatureToggles
